// This file needs to use CommonJS module.exports so that Webpack can import it without Babel
module.exports = {
  assets: '/assets',
  courseLaunch: '/api/courses/v1/validation',
  courseBestPractices: '/api/courses/v1/quality',
  home: '/home',
  zendesk: '/zendesk_proxy/v0',
};
